module.exports = __webpack_public_path__ + "congrats-robots-placeholder.8ed1f7.jpg";